import { makeStyle } from '../../../utils';
import { body2, bold, button, caption, columnCenter, h5, h6, rowCenter, subTitle1 } from '../../../resources/styles';

const styles = {};

styles['tab_content'] = makeStyle({ margin: '0 auto', padding: '16px 0' }, {}, {}, { padding: '0 0 16px' });

styles['tab_content_back'] = makeStyle({ backgroundColor: '#ccc4' });

styles['tab_heading'] = makeStyle({ ...h5, maxWidth: '80%', margin: '0 auto', padding: '16px 0', textAlign: 'center' });

styles['tab_message'] = makeStyle({ ...subTitle1, maxWidth: '80%', margin: '0 auto', padding: '16px 0' });

styles['tab_footing'] = makeStyle({ ...subTitle1, maxWidth: '80%', margin: '0 auto', padding: '16px 0' });

styles['tab_cards'] = makeStyle({}, { display: 'flex' }, { display: 'flex', flexWrap: 'wrap' });

styles['tab_card'] = makeStyle({ ...columnCenter, boxSizing: 'border-box', padding: 16 },{ flex: 1 }, { flex: 2 },{ margin: '0 15%' });

styles['tab_cards_padding'] = makeStyle({},{minWidth: '5%', flex: 1},{flex: 1});

styles['tandc_container'] = makeStyle({ paddingBottom: 32, ...columnCenter });

styles['tandc_title'] = makeStyle([h5, { textAlign: 'center', padding: 32 }]);

styles['tandc_ol'] = makeStyle({ margin: 0, maxWidth: '80%', margin: '0 auto', padding: '0 24px 0 40px' });

styles['tandc'] = makeStyle(subTitle1, {}, {}, body2);

styles['tandc_text_in_card'] = makeStyle([caption, { fontSize: 12, marginTop: 24 }]);

styles['tandc_link_in_card'] = makeStyle([caption, { fontSize: 12, color: 'var(--theme-color)', textDecoration: 'underline' }]);

styles['start_button'] = makeStyle({
    borderRadius: 6,
    backgroundColor: 'var(--theme-color)',
    textAlign: 'center',
    color: 'white',
    padding: '8px 24px',
    margin: '24px auto 0',
    display: 'flex',
    alignItems: 'center',
    ...button,
});

styles['image_containter'] = makeStyle({
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: '64px 0px',
}, {}, {}, { padding: '24px 0px' });

styles['right_card_override'] = makeStyle({}, { marginLeft: '50%' }, { width: 400 });

export default styles;
